import React from 'react';

import { type UserSchema } from 'stores/User';
import { formatDateShort } from 'utils/Dates';

import SsoAvatar from '../SsoAvatar/SsoAvatar';
import {
  Caption,
  Column,
  Container,
  MainLabel,
  MetadataContainer,
  NameContainer,
  Subtitle,
  Title,
} from './ProfileCard.styles';

export interface ProfileCardProps {
  userData: UserSchema;
}

function ProfileCard({ userData }: ProfileCardProps) {
  const { displayName, email, cachedPhotoURL, role, dateCreated } = userData;

  const dateCreatedLabel = formatDateShort(dateCreated);

  return (
    <Container>
      <SsoAvatar icon="google" src={cachedPhotoURL} />

      <NameContainer>
        <Title>{displayName}</Title>
        <Caption>{email}</Caption>
      </NameContainer>

      <MetadataContainer>
        <Column>
          <Subtitle>Joined</Subtitle>
          <MainLabel>{dateCreatedLabel}</MainLabel>
        </Column>

        <Column>
          <Subtitle>Role</Subtitle>
          <MainLabel>{role}</MainLabel>
        </Column>
      </MetadataContainer>
    </Container>
  );
}

export default ProfileCard;
